import { Flex } from '@chakra-ui/react';

function DodoDotStudio() {
  return <Flex flex="1" />;
}

export default DodoDotStudio;
